// removed by extract-text-webpack-plugin
module.exports = {"languageSwitcher":"src-components-languageSwitcher----languageSwitcher-module---languageSwitcher---23lUu","active":"src-components-languageSwitcher----languageSwitcher-module---active---2vZmW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/languageSwitcher/languageSwitcher.module.pcss
// module id = 299
// module chunks = 104033720589488